import {
    GET_SIDEBAR_MENU_REQUEST, GET_SIDEBAR_MENU_SUCCESS, GET_SIDEBAR_MENU_FAIL,
    GET_ALL_SIDEBAR_MENUS_REQUEST, GET_ALL_SIDEBAR_MENUS_SUCCESS, GET_ALL_SIDEBAR_MENUS_FAIL,
    GET_ORDERED_SIDEBAR_MENUS_REQUEST, GET_ORDERED_SIDEBAR_MENUS_SUCCESS, GET_ORDERED_SIDEBAR_MENUS_FAIL,
    GET_SIDEBAR_MENUS_BY_ROLE_REQUEST, GET_SIDEBAR_MENUS_BY_ROLE_SUCCESS, GET_SIDEBAR_MENUS_BY_ROLE_FAIL,
    GET_SIDEBAR_MENUS_BY_STATUS_REQUEST, GET_SIDEBAR_MENUS_BY_STATUS_SUCCESS, GET_SIDEBAR_MENUS_BY_STATUS_FAIL,
    GET_ROOT_SIDEBAR_MENUS_REQUEST, GET_ROOT_SIDEBAR_MENUS_SUCCESS, GET_ROOT_SIDEBAR_MENUS_FAIL,
    GET_CHILD_SIDEBAR_MENUS_REQUEST, GET_CHILD_SIDEBAR_MENUS_SUCCESS, GET_CHILD_SIDEBAR_MENUS_FAIL,
    CREATE_SIDEBAR_MENU_REQUEST, CREATE_SIDEBAR_MENU_SUCCESS, CREATE_SIDEBAR_MENU_FAIL,
    UPDATE_SIDEBAR_MENU_REQUEST, UPDATE_SIDEBAR_MENU_SUCCESS, UPDATE_SIDEBAR_MENU_FAIL,
    DELETE_SIDEBAR_MENU_REQUEST, DELETE_SIDEBAR_MENU_SUCCESS, DELETE_SIDEBAR_MENU_FAIL,
    SET_SIDEBAR_MENU_LOADING, UPDATE_SIDEBAR_MENU, GET_SIDEBAR_MENUS_BY_ROLE_ADMIN_REQUEST,
    GET_SIDEBAR_MENUS_BY_ROLE_ADMIN_SUCCESS, GET_SIDEBAR_MENUS_BY_ROLE_ADMIN_FAIL
} from '../actions/sidebarMenuActions';

const initialState = {
    menus: [],
    adminMenus: [],     // admin (Management)
    currentMenu: null,
    loading: false,
    message: '',
    error: null
};

function sidebarMenuReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_SIDEBAR_MENU:
            return {
                ...state,
                loading: true,
                menu: action.menu
            };

        // --- SET LOADING ---
        case SET_SIDEBAR_MENU_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        // --- Récupérer un menu ---
        case GET_SIDEBAR_MENU_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_SIDEBAR_MENU_SUCCESS:
            return {
                ...state,
                currentMenu: action.payload,
                loading: false,
                message: 'Menu récupéré avec succès'
            };
        case GET_SIDEBAR_MENU_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                message: 'Échec de la récupération'
            };

        // --- Récupérer tous les menus ---
        case GET_ALL_SIDEBAR_MENUS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_ALL_SIDEBAR_MENUS_SUCCESS:
            return {
                ...state,
                menus: action.payload,
                loading: false,
                message: 'Menus récupérés avec succès'
            };
        case GET_ALL_SIDEBAR_MENUS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Récupérer menus ordonnés ---
        case GET_ORDERED_SIDEBAR_MENUS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_ORDERED_SIDEBAR_MENUS_SUCCESS:
            return {
                ...state,
                menus: action.payload,
                loading: false,
                message: 'Menus ordonnés récupérés avec succès'
            };
        case GET_ORDERED_SIDEBAR_MENUS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Récupérer menus par rôle ---
        case GET_SIDEBAR_MENUS_BY_ROLE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_SIDEBAR_MENUS_BY_ROLE_SUCCESS:
            return {
                ...state,
                menus: action.payload,
                loading: false,
                message: 'Menus filtrés par rôle avec succès'
            };
        case GET_SIDEBAR_MENUS_BY_ROLE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };
            // --- Récupérer menus par rôle admin(mangment)---
        case GET_SIDEBAR_MENUS_BY_ROLE_ADMIN_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_SIDEBAR_MENUS_BY_ROLE_ADMIN_SUCCESS:
            return {
                ...state,
                adminMenus: action.payload,
                loading: false,
                message: 'Menus filtrés par rôle avec succès'
            };
        case GET_SIDEBAR_MENUS_BY_ROLE_ADMIN_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Récupérer menus par statut ---
        case GET_SIDEBAR_MENUS_BY_STATUS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_SIDEBAR_MENUS_BY_STATUS_SUCCESS:
            return {
                ...state,
                menus: action.payload,
                loading: false,
                message: 'Menus filtrés par statut avec succès'
            };
        case GET_SIDEBAR_MENUS_BY_STATUS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Récupérer menus racines ---
        case GET_ROOT_SIDEBAR_MENUS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_ROOT_SIDEBAR_MENUS_SUCCESS:
            return {
                ...state,
                menus: action.payload,
                loading: false,
                message: 'Menus racines récupérés avec succès'
            };
        case GET_ROOT_SIDEBAR_MENUS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Récupérer menus enfants ---
        case GET_CHILD_SIDEBAR_MENUS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_CHILD_SIDEBAR_MENUS_SUCCESS:
            return {
                ...state,
                menus: action.payload,
                loading: false,
                message: 'Menus enfants récupérés avec succès'
            };
        case GET_CHILD_SIDEBAR_MENUS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Créer un menu ---
        case CREATE_SIDEBAR_MENU_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case CREATE_SIDEBAR_MENU_SUCCESS:
            return {
                ...state,
                menus: [...state.menus, action.payload],
                loading: false,
                message: 'Menu créé avec succès'
            };
        case CREATE_SIDEBAR_MENU_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Mettre à jour un menu ---
        case UPDATE_SIDEBAR_MENU_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case UPDATE_SIDEBAR_MENU_SUCCESS:
            return {
                ...state,
                menus: state.menus.map(menu =>
                    menu.id === action.payload.id ? action.payload : menu
                ),
                currentMenu: state.currentMenu?.id === action.payload.id
                    ? action.payload
                    : state.currentMenu,
                loading: false,
                message: 'Menu mis à jour avec succès'
            };
        case UPDATE_SIDEBAR_MENU_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Supprimer un menu ---
        case DELETE_SIDEBAR_MENU_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case DELETE_SIDEBAR_MENU_SUCCESS:
            return {
                ...state,
                menus: state.menus.filter(menu => menu.id !== action.payload.menuId),
                currentMenu: state.currentMenu?.id === action.payload.menuId
                    ? null
                    : state.currentMenu,
                loading: false,
                message: 'Menu supprimé avec succès'
            };
        case DELETE_SIDEBAR_MENU_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        default:
            return state;
    }
}

export default sidebarMenuReducer;